import { userSlice } from './slice'

export const {
  setUser,
  setLoading,
  setWidgetUsers,
  setErrorMessage,

  /* User Register */
  setUserRegisterButtonStepValue,
  setUserFormCredentials,
  resetUserForm,
  setUserPersonalDataForm,
  setUserRegisterLoading,
  setUserRegisterSuccess,
  setUserRegisterError,
  setUserRegisterEmail,
  resetUserRegisterState,
  resetUserRegisterSuccessState,

  /* Validate Email Reducers */
  setValidateEmailLoading,
  setValidateEmailSuccess,
  setValidateEmailError,
  resetValidateEmailState,

  /* Validate Email Reducers */
  setValidateEmailForStockSaleLoading,
  setValidateEmailForStockSaleSuccess,
  setValidateEmailForStockSaleError,
  resetValidateEmailForStockSaleState,

  /* Change Password Reducers */
  setChangePasswordLoading,
  setChangePasswordSuccess,
  setChangePasswordError,
  resetChangePasswordState,

  /* Update User Login Reducers */
  setUpdateUserLoginPersonalDataLoading,
  setUpdateUserLoginPersonalDataSuccess,
  setUpdateUserLoginPersonalDataError,
  setUpdateUserLoginPersonalDataNewEmail,
  resetUserPersonalDataState,

  /* Delete Auth User Reducers */
  setDeleteAuthUserLoading,
  setDeleteAuthUserSuccess,
  setDeleteAuthUserErrorMessage,
  resetDeleteAuthUserState,

  /* User Subscriptions */
  resetUserSubscriptions,
  setUserSubscriptions
} = userSlice.actions

